import { Alert } from '@mui/material';
import React from 'react';
import { useFutureAndGeneratedInvoices } from '../../api/InvoiceApi';
import { AuthData } from '../../context/auth';
import { PolicyData, withPolicyContext } from '../../context/policy';
import { FETCH_INVOICES_FAILURE } from '../../data/labelsAndMessages';
import LargeCenterSpinner from '../LargeCenterSpinner';
import NewInvoicesTable from '../NewInvoicesTable';

interface Props {
	authData: AuthData;
	policyData: PolicyData;
}

const InvoicesView = (props: Props) => {
	const { authData, policyData } = props;
	const authToken = authData?.auth?.authorizationToken;
	const hasPermission = authData?.hasPermission;
	const { policy } = policyData;

	const {
		data: policyCheckInvoices,
		isLoading: areInvoicesLoading,
		isError,
	} = useFutureAndGeneratedInvoices(
		policy.locator,
		authToken,
		hasPermission('policy.fetch'),
	);

	const invoicesForPolicy =
		policyCheckInvoices?.generatedInvoices?.map((i) => i.invoice) || [];

	if (isError) {
		<Alert severity='error'>{FETCH_INVOICES_FAILURE()}</Alert>;
	}

	if (areInvoicesLoading) {
		return <LargeCenterSpinner />;
	}

	return (
		<NewInvoicesTable
			invoices={invoicesForPolicy}
			policyholderLocator={policy.policyholderLocator}
			useInvoiceCurrency
		/>
	);
};

export default withPolicyContext<Props>(InvoicesView);
